import React from "react";

interface DocPreviewerProps {
  documentUrl: string;
  title?: string;
  setShowPreviewer: (show: boolean) => void;
  containerClassName?: string;
}

const DocPreviewer: React.FC<DocPreviewerProps> = ({
  documentUrl,
  title,
  setShowPreviewer,
  containerClassName,
}) => {
  return (
    <div className="w-full h-full flex flex-col">
      <div
        className={`fixed inset-0 bg-black/50 flex justify-center items-center z-[999] ${containerClassName}`}
      >
        <div
          className="relative w-4/5 max-w-[900px] h-[80vh] bg-white dark:bg-gray-800 rounded-xl shadow-2xl overflow-hidden flex flex-col"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header with title and close button */}
          {title && (
            <div className="flex items-center justify-between px-6 py-4 bg-[#3C3C3C]">
              <h2 className="text-base font-medium text-pure-white truncate pr-4">
                {title}
              </h2>
              <button
                className="bg-[#ff5c5c] text-white text-xl w-8 h-8 rounded-full cursor-pointer shadow-md hover:bg-[#ff4242] transition-colors flex items-center justify-center flex-shrink-0"
                onClick={() => setShowPreviewer(false)}
              >
                ×
              </button>
            </div>
          )}

          {/* Close button when no title */}
          {!title && (
            <button
              className="absolute top-3 right-3 bg-[#ff5c5c] text-white text-xl w-8 h-8 rounded-full cursor-pointer shadow-md hover:bg-[#ff4242] transition-colors z-10"
              onClick={() => setShowPreviewer(false)}
            >
              ×
            </button>
          )}

          {/* Document iframe */}
          <iframe
            src={documentUrl}
            className="flex-1 w-full h-full border-none"
            frameBorder="0"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default DocPreviewer;
